<template>
  <div class="ui grid">
    <div class="five wide column">
      <div class="ui secondary pointing vertical menu">
        <a
          class="item"
          :data-tab="tab.key"
          v-for="(tab, tidx) in tabs"
          :key="tidx"
          ref="tabs"
          >{{ tab.key }}</a
        >
      </div>
    </div>
    <div class="eleven wide column">
      <div
        class="ui tab basic vertical segment"
        :data-tab="tab.key"
        v-for="(tab, tidx) in tabs"
        :key="tidx"
      >
        <div class="ui bulleted list" v-if="typeof tab.value == 'object'">
          <div class="item" v-for="(vl, index) in tab.value" :key="index">
            {{ index }}: <strong>{{ vl }}</strong>
          </div>
        </div>
        <div class="ui bulleted list" v-else>
          <span>{{ tab.value }}</span>
        </div>
      </div>
    </div>
    <!-- <pre>{{ instance }}</pre> -->
  </div>
</template>

<script>
export default {
  name: "RobocreditInstanceModalGeneral",
  props: {
    request_body: Object,
  },
  data() {
    return {};
  },
  computed: {
    tabs() {
      let vm = this;
      if (vm.request_body) {
        return Object.keys(vm.request_body).map((k) => {
          return { key: k, value: vm.request_body[k] };
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    update() {
      let vm = this;
      window.jQuery(vm.$refs.tabs).tab();
    },
  },
  watch: {},
};
</script>
